export default function ResponderFooter({ align = "end" }) {
    const alignClass = align === "center" ? "text-center" : "text-center";

    return (
        <footer className="bg-white">
            <div className={`border-t border-[#c2a8f033] py-1.5 ${alignClass} text-[11px] text-gray-600`}>
                Design and Developed By :-{" "}
                <span className="font-medium text-[#7f35b2]">VRSamadhan Tech Solution</span>
            </div>
        </footer>
    );
}
